import GeStudentApiService from "@/core/services/geStudentApi.service";
import { PedagogicalDiaryApiService } from "@/core/services/pedagogicalDiaryApi.service";
import JwtService from "@/core/services/jwt.service";
import Axios from "axios";
import { SET_PERSONAL_INFO, RESET_PROFILE_STATE } from "./profile.module";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
};

const actions = {
  [LOGIN](context, credentials) {
    state.user = {}
    return new Promise((resolve, reject) => {
      GeStudentApiService.post("auth/login", credentials)
        .then(({ data }) => {
          if (data.status) {
            context.commit(SET_AUTH, data.data);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          if (!response) {
            reject({
              status: false,
              message:
                "Ha ocurrido un error al intentar conectar con el servidor 🙁",
            });
          }
          if (response.status === 401) {
            reject(response.data);
          }
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [LOGOUT](context) {
    if (JwtService.getToken()) {
      GeStudentApiService.setHeader();
      PedagogicalDiaryApiService.setHeader();
      return new Promise((resolve) => {
        GeStudentApiService.get("auth", "logout").then(({ data }) => {
          context.commit(PURGE_AUTH);
          context.commit(RESET_PROFILE_STATE);
          resolve(data);
        });
      });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve) => {
      GeStudentApiService.post("login", credentials)
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      GeStudentApiService.setHeader();
      PedagogicalDiaryApiService.setHeader();
      GeStudentApiService.get("auth", "me")
        .then(({ data }) => {
          let authData = {
            user: data,
            access_token: JwtService.getToken(),
          };
          context.commit(SET_AUTH, authData);
          context.commit(SET_PERSONAL_INFO, data);
        })
        .catch((error) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_PASSWORD](context, payload) {
    const password = payload;

    return GeStudentApiService.put("password", password).then(({ data }) => {
      context.commit(SET_PASSWORD, data);
      return data;
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, authData) {
    state.isAuthenticated = true;
    state.user = authData.user;
    state.errors = {};
    JwtService.saveToken(authData.access_token);
  },
  [SET_PASSWORD](state, password) {
    state.user.password = password;
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.errors = {};
    state.user = {};
    JwtService.destroyToken();
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
